import React from "react";
import "../styles/Footer.css"; 
import { Link } from "react-router-dom";

// ✅ Import White Bold Logo
import { ReactComponent as WhiteBoldLogo } from "../assets/Transparent svg/Bold Logo with Text/White Bold Logo.svg";

// ✅ Import Pilotly Logo (make sure it's in your assets folder)
import pilotlyLogo from "../assets/Transparent svg/pilotly-logo.png";


const Footer = () => {
  return (
    <footer className="footer-container">
      {/* ✅ Main Frame for All Items */}
      <div className="footer-frame">

        {/* ✅ Frame for Logo & Description */}
        <div className="footer-logo-frame">
          <WhiteBoldLogo className="footer-logo-svg" />

          <p className="footer-description">
            Our solutions make dispatch <br />
            faster and cheaper. Contact us for <br />
            more information.
          </p>
        </div>

        {/* ✅ New Frame for Menu */}
        <div className="footer-info-frame">
          <div className="footer-menu-frame">
            <p className="footer-menu-title">Menu</p>
            <ul className="footer-menu-list">
              <li><Link to="/" className="footer-link">Home</Link></li>
              <li><Link to="/pricing" className="footer-link">Pricing</Link></li>
              <li><Link to="/about-us" className="footer-link">About Us</Link></li>
              <li><Link to="/contact" className="footer-link">Contact</Link></li>
              <li><Link to="/LegalHome" className="footer-link">Legal Home</Link></li>
            </ul>
          </div>

          {/* ✅ Get in Touch */}
          <div className="footer-contact-frame">
            <p className="footer-contact-title">Get in Touch</p>
            <div className="footer-contact-info">
              <p className="footer-email">support@cjetdispatch.com</p>
              <img src="/socials-icon.svg" alt="Social Icons" className="footer-socials" />
            </div>
          </div>
        </div>
      </div>
      
      {/* ✅ Footer Bottom Section */}
      <div className="footer-bottom-frame">
        <div className="footer-copyright-frame">
          <img src="/copyright-icon.svg" alt="Copyright Icon" className="footer-copyright-icon" />
          <p className="footer-copyright-text">
            2025 Cjet Dispatch LLC. All rights reserved
          </p>
        </div>

        

        <div className="footer-terms-frame">
          <Link to="/terms" className="footer-terms">Terms & Conditions</Link>
          <Link to="/privacy" className="footer-privacy">Privacy Policy</Link>
          <Link to="/Refund" className="footer-privacy">Refund Policy</Link>
          
        </div>


        <div className="footer-poweredby-frame">
          <span className="footer-poweredby-text">Powered by</span>
          <img src={pilotlyLogo} alt="Pilotly Logo" className="footer-pilotly-logo" />
        </div>
      </div>
    </footer>
  );
};

export default Footer;
